// extracted by mini-css-extract-plugin
export default {"finance":"index_finance_JOyre"};